import ContractEquipmentsTable from "./ContractEquipmentsTable";

export default ContractEquipmentsTable;
